import type { SortedField } from "@/types";

export default function transformSortedFieldsToString(fields: SortedField[]): string {
  if (fields.length < 1) {
    return ''
  }

  return fields.map(
    f => f.direction === 'desc' ? `-${f.field}` : f.field
  ).join(',')
}